'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Spinner = require('@sitebase/ui-kit/es/Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

var _mastercardLogo = require('../../assets/mastercard-logo.png');

var _mastercardLogo2 = _interopRequireDefault(_mastercardLogo);

var _visaLogo = require('../../assets/visa-logo.png');

var _visaLogo2 = _interopRequireDefault(_visaLogo);

var _AssetsPathProvider = require('../AssetsPathProvider');

var _types = require('../../types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadingSpinner = function LoadingSpinner(_ref) {
  var loadingSpinnerTitle = _ref.loadingSpinnerTitle,
      loadingSpinnerMessage = _ref.loadingSpinnerMessage,
      countryCode = _ref.countryCode;
  return _react2.default.createElement(
    'div',
    { className: 'qd__loading-spinner' },
    _react2.default.createElement(
      'div',
      { className: 'qd__loading-spinner-container' },
      _react2.default.createElement(_Spinner2.default, { outfit: 'normal blue' })
    ),
    loadingSpinnerMessage ? _react2.default.createElement(
      'div',
      { className: 'qd__loading-spinner-message' },
      _react2.default.createElement(
        'h3',
        { className: 'qd__loading-spinner-message-title' },
        loadingSpinnerTitle
      ),
      _react2.default.createElement(
        'p',
        { className: 'qd__loading-spinner-message-text' },
        loadingSpinnerMessage
      )
    ) : null,
    _react2.default.createElement(
      _AssetsPathProvider.AssetsPathConsumer,
      null,
      function (_ref2) {
        var prefixes = _ref2.prefixes;
        return _react2.default.createElement(
          'div',
          { className: 'qd__loading-spinner-logo-container' },
          countryCode !== 'DE' && _react2.default.createElement('img', {
            className: 'qd__loading-spinner-logo qd__loading-spinner-logo--visa',
            alt: 'Visa logo',
            src: prefixes[_visaLogo2.default] ? prefixes[_visaLogo2.default] + _visaLogo2.default : _visaLogo2.default
          }),
          _react2.default.createElement('img', {
            className: 'qd__loading-spinner-logo',
            alt: 'MasterCard logo',
            src: prefixes[_mastercardLogo2.default] ? prefixes[_mastercardLogo2.default] + _mastercardLogo2.default : _mastercardLogo2.default
          })
        );
      }
    )
  );
};

exports.default = LoadingSpinner;